import React, { Component } from 'react';

import { Chart } from 'react-google-charts';

export class StackbarChartPanel extends Component {

    isDataPresent = () => {
      if (this.props.routesList.filter((route) => {
        return route.selected;
      }).length > 0) {return true} else {return false}
    }

    getCols = () => {
      var cols = [];
      cols.push({label: 'Id', type: 'string'})
      this.props.routesList.filter((route) => {
           return route.selected;
         }).map((route, index) => {
           cols.push({label:route.from.name + " - " +route.to.name, type:'number'}) ;
           return null;
         });
      return cols;
    }

    getChartData = () => {
      var chartData = [];
      chartData.push('Drive');

      this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        //chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
        chartData.push(route.endDate.getHours()-route.startDate.getHours());
        return null;
      });

      return [chartData];
    }

    getChartColors = () => {
      return this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        return '' + route.pathColor;
      })

    }


    getChart = () => {
      if (this.isDataPresent()) {
        return (
          <Chart
            chartType="BarChart"
            columns={this.getCols()}
            rows={this.getChartData()}
            options={{
                legend: { position: 'top', maxLines: 2 },
                bar: { groupWidth: '75%' },
                isStacked: true,
                colors: this.getChartColors()
              }}
            graph_id="BarChart"
            width="100%"
            height="160px"
          />
        )
      } else {
        return <span></span>;
      }
    }

    render() {
        return(

          <div className={'my-pretty-chart-container'}>
            {this.getChart()}
          </div>
        );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/StackbarChartPanel.js